module.exports = __webpack_public_path__ + "static/media/full-screen-selected-icon.9b6fd82b.svg";